import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {Cliente} from '../../../model/catalogo';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'ajuda-variaveis-modal',
    templateUrl: './ajuda-variaveis-modal.component.html',
    styleUrls: ['./ajuda-variaveis-modal.component.css']
})

export class AjudaVariaveisComponent {

    constructor(private globalService: GlobalService, public modalService: ModalService, public pesquisaService: PesquisasFiltroApiService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
    }

    private sub: any;

    pagina: number = 1;
    qtdPorPagina: number = 7;
    totalPaginas: number = 1;
    campoBusca = new FormControl('', []);
    tipoCliente = new FormControl('', []);
    selecionaAutomatico: boolean = false;
    matricula: boolean = false;
    resultado: Array<Cliente> = null;
    visiveis: Array<Cliente> = null;
    selecionado: Cliente = null;
    mensagemErro: string = '';

    mudarPagina(pag: number, desabilitado: string) {

        if (desabilitado == 'true') {
            return false;
        }

        this.pagina = pag;
        this.visiveis = new Array<Cliente>();
        let ind = 1;
        this.resultado.forEach(res => {
            if (ind > (pag - 1) * this.qtdPorPagina && ind <= pag * this.qtdPorPagina) {
                this.visiveis.push(res);
            }
            ind++;
        });
    }

    confirmar() {
        if (this.selecionado == null) {
            this.mensagemErro = 'Selecione o cliente ou clique em \'Fechar\'';
        } else {
            this.modalService.incluirDadosGerados(this.selecionado);
            this.modalService.fecharPaginaModal();
        }
    }

    cancelar() {
        this.modalService.fecharPaginaModal();
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/ajuda-variaveis-modal/ajuda-variaveis-modal.component.ts